import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, Theme } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $headerCard': {
      color: TextColors.dark,
    },
    '& $superheading': {
      color: SecondaryColors.dark,
    },
  },
};
const darkTheme = {
  root: {
    '& $headerCard': {
      color: TextColors.light,
    },
    '& $superheading': {
      color: SecondaryColors.main,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      minHeight: '35px',
    },
    headerCard: {
      marginBottom: muiTheme.spacing(3),
    },
    superHeading: {
      '& .MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },
    title: {
      '&.MuiTypography-root': {
        color: 'inherit',
        marginBottom: '-.125em',
      },
    },
    ctaWrapper: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: muiTheme.spacing(5),
    },
    contentCards: {
      '& .column': {
        display: 'flex',
      },
      '& .MuiCard-root': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
      '& .MuiCard-root > .MuiCardContent-root': {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
      },
    },
  }),
  { name: 'GenTPSRelatedSolution' },
);

export default useStyles;
